module.exports = __webpack_public_path__ + "static/img/CBO_250x250px-BW.b33aa51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/members/CBO_250x250px-BW.png
// module id = 541
// module chunks = 1